export class DespawnOffscreen {
    public wasOnscreen: boolean;

    constructor() {
        this.wasOnscreen = false;
    }
}
